import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import he from "he";
import Loader from "../../Loader";

const BlogContent = () => {
  const { page } = useSelector((state) => state.data);
  const [blogData, setBlogData] = useState("");

  useEffect(() => {
    if (page?.data?.["blogs"]?.siteId === 2 && page.data["blogs"].htmlContent) {
      const decodedHtml = he.decode(page.data["blogs"].htmlContent);
      setBlogData(decodedHtml);
    }
  }, [page]);

  if (!page || !page.data) return <Loader />;

  return (
    <div id="rs-blog-content">
      {blogData && <div dangerouslySetInnerHTML={{ __html: blogData }} />}
    </div>
  );
};

export default BlogContent;
